import FullPagePaginationControls from "../react_components/full_page_pagination_controls";
import ResponsivePageAdContainer from "../react_components/ads/responsive_page_ad_container";
import SeriesList from "../react_components/series/series_list";
import SeriesHeader from "../react_components/series/series_header";

export const SeriesShowComponents = {
  FullPagePaginationControls,
  ResponsivePageAdContainer,
  SeriesList,
  SeriesHeader,
};
